import { useState } from "react";

export const useGroupDestinationsModal = () => {
  const [open, setOpen] = useState(false);
  return {
    open,
    openModal: () => setOpen(true),
    closeModal: () => setOpen(false),
  };
};
